import styled, { css } from 'styled-components';

const labelVariants = {
    light: css`
        border-color: ${({ theme }) => theme.colors.navy};
        background-color: white;
    `,
    dark: css`
        border-color: ${({ theme }) => theme.colors.mediumGrey};
        background-color: transparent;
    `,
};

const SwitchInput = styled.input`
    height: 0;
    width: 0;
    position: absolute;
    visibility: hidden;
`;

const SwitchLabel = styled.label<{ $variant?: keyof typeof labelVariants }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 52px;
    height: 32px;
    border-radius: 100px;
    border: 2px solid ${({ theme }) => theme.colors.navy};
    position: relative;
    background-color: white;
    transition: background-color 0.2s, border-color 0.2s, opacity 0.2s;

    ${SwitchInput}:checked + & {
        background-color: ${({ theme }) => theme.colors.green};
        border-color: transparent;
    }

    ${SwitchInput}[disabled] + & {
        pointer-events: none;
        opacity: 0.6;
    }

    ${({ $variant }) => $variant && labelVariants[$variant]}
`;

const SwitchButton = styled.span`
    content: '';
    position: absolute;
    top: 50%;
    left: 2px;
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
    border-radius: 50%;
    transition: 0.2s;
    background: ${({ theme }) => theme.colors.mediumGrey};

    ${SwitchInput}:checked + ${SwitchLabel} & {
        left: calc(100% - 2px);
        transform: translateX(-100%) translateY(-50%);
        background: white;
    }

    ${SwitchLabel}:active & {
        width: 26px;
    }
`;

type Props = {
    id: string;
    toggled: boolean;
    disabled?: boolean;
    variant?: keyof typeof labelVariants;
    onChange: () => void;
};

const Switch = ({ id, toggled, disabled, onChange, variant }: Props) => {
    return (
        <>
            <SwitchInput
                className="switch-checkbox"
                id={id}
                type="checkbox"
                checked={toggled}
                onChange={onChange}
                disabled={disabled}
            />
            <SwitchLabel
                className="switch-label"
                htmlFor={id}
                $variant={variant}
            >
                <SwitchButton className="switch-button" />
            </SwitchLabel>
        </>
    );
};

export default Switch;
